import { Heading, Text } from "@chakra-ui/react";
import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";

import { T_KEY } from "@/src/constants/translationsKey";

import styles from "./ItemList.module.scss";

export interface Item {
  category: string;
  id: number;
  title: string;
  link: string;
}

interface IItemsProps {
  items: Item[];
}

export const categoryDivider = ">";

export function Items({ items }: IItemsProps) {
  const { t } = useTranslation(T_KEY);

  return (
    <>
      {items.map(item => (
        <li key={item.id}>
          <a href={item.link}>
            <div>
              <Text fontSize="md" color="gray.400" mb="8px">
                {/* FIXME: 임시 */}
                {`${t(item.category[0])} ${categoryDivider} ${t(
                  item.category[1]
                )}`}
              </Text>
              <Heading size="md" color="gray.800">
                {item.title}
              </Heading>
            </div>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 6L15 12L9 18"
                stroke="#222222"
                strokeWidth="1.6"
                strokeLinecap="square"
                strokeLinejoin="round"
              />
            </svg>
          </a>
        </li>
      ))}
    </>
  );
}

interface ItemListProps {
  items: Item[];
  columned?: boolean;
  restProps?: React.HTMLAttributes<HTMLUListElement>;
}

export default function ItemList({
  items,
  columned = false,
  restProps,
}: ItemListProps): React.ReactElement {
  return (
    <ul
      className={clsx(
        styles.itemListWrapper,
        columned && styles.itemListWrapperColumned
      )}
      {...restProps}
    >
      {items.length > 0 ? <Items items={items} /> : null}
    </ul>
  );
}
